var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaution = function SvgCaution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E89806",
    d: "M79.987 40c0-22.092-17.906-40-39.994-40C17.906 0 0 17.908 0 40s17.906 40 39.993 40 39.994-17.908 39.994-40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42.533 46.718h-5.08a1.82 1.82 0 0 1-1.82-1.822v-23c0-1.006.815-1.822 1.82-1.822h5.08c1.006 0 1.822.816 1.822 1.822v23a1.82 1.82 0 0 1-1.822 1.822M39.993 61.22a4.36 4.36 0 0 1-4.36-4.361v-.001a4.362 4.362 0 1 1 8.722 0 4.36 4.36 0 0 1-4.362 4.363"
  })));
};
export default SvgCaution;